export interface InitiateOutgoingCallFormProps {
  toNumber: string;
  fromUserId: string;
  outboundPhoneNumberId?: string;
}

const _new = ({
  fromUserId,
  toNumber,
  outboundPhoneNumberId,
}: {
  fromUserId: string;
  toNumber?: string;
  outboundPhoneNumberId?: string;
}) => ({
  fromUserId,
  toNumber: toNumber || '',
  outboundPhoneNumberId: outboundPhoneNumberId || '',
});

const toForm = ({toNumber, fromUserId, outboundPhoneNumberId}: InitiateOutgoingCallFormProps) => ({
  toNumber,
  fromUserId,
  outboundPhoneNumberId,
});

const toMutation = ({
  toNumber,
  fromUserId,
  outboundPhoneNumberId,
}: InitiateOutgoingCallFormProps) => ({
  toNumber,
  fromUserId,
  outboundPhoneNumberId,
});

export default {
  new: _new,
  toForm,
  toMutation,
};
